import { nullable } from '@ipfabric/utils/fp/nullable';
import { prop } from '@ipfabric/utils/fp/prop';
import type { SecuritySchemaMergedState } from 'components/SecuritySchema/model/SecuritySchemaModel';
import {
  type RuleChainScope,
  isRuleChainScope,
} from 'components/SecuritySchema/model/SecuritySchemaScope';
import { pipe } from 'fp-ts/lib/function';

export const selectRuleChainScope = (
  state: SecuritySchemaMergedState,
): RuleChainScope | null =>
  pipe(state, prop('scope'), nullable.fromPredicate(isRuleChainScope));
